import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { testimonials } from '../data/testimonials';
export function TestimonialsSection() {
  return <section className="bg-brand-alt px-4 py-20 md:py-24" data-id="element-164" data-mp="1n00ra3zw93vo">
      <Reveal className="mx-auto max-w-6xl" data-id="element-165" data-mp="1mzisp0predkl">
        <div className="mb-12 text-center" data-id="element-166" data-mp="1r1dvyar93110">
          <p className="text-[10px] font-extrabold uppercase tracking-[0.22em] text-brand-orange sm:text-xs" data-id="element-167" data-mp="1r02r07m2jn8b">
            Beliebt bei Lehrkräften
          </p>
          <h2 className="mt-4 flex items-center justify-center gap-3 text-3xl font-extrabold text-brand-navy md:text-4xl" data-id="element-168" data-mp="1i1h11re9p5xi">
            <StarIcon className="h-6 w-6 shrink-0 fill-brand-orange text-brand-orange" aria-hidden="true" data-id="element-169" data-mp="1427tth81hm5o" />
            Was Kunstlehrkräfte sagen.
          </h2>
          <div className="mt-4 flex items-center justify-center gap-1" aria-label="Durchschnittliche Bewertung 5 von 5 Sternen" data-id="element-170" data-mp="2ygim5znueyg7">
            {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="h-5 w-5 fill-brand-orange text-brand-orange" aria-hidden="true" data-id="element-171" data-mp="2uzzvou5egivs" />)}
          </div>
        </div>
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-172" data-mp="34tgqo1h9w411">
          {testimonials.map((testimonial, index) => <article key={index} className="flex min-h-[210px] flex-col rounded-2xl border border-brand-line bg-brand-main p-7 shadow-sm" data-id="element-173" data-mp="2c2qdfgbt9bg4" data-mpi={index}>
              <div className="flex gap-1" aria-label="5 von 5 Sternen" data-id="element-174" data-mp="275q8j8qp6eql">
                {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="h-4 w-4 fill-brand-orange text-brand-orange" aria-hidden="true" data-id="element-175" data-mp="2h22ypwn1aagl" />)}
              </div>
              <div className="mt-5 flex-1" data-id="element-176" data-mp="3sfx0d8l3tfcs">
                {testimonial.quote ? <p className="text-base font-semibold leading-relaxed text-brand-text" data-id="element-177" data-mp="3fk2o9hej6ws">
                    {testimonial.quote}
                  </p> : <PlaceholderLines data-id="element-178" data-mp="dcyh63jrllmg" />}
              </div>
              <div className="mt-6 space-y-2" data-id="element-179" data-mp="davjqyga8q7p">
                {testimonial.name ? <p className="text-sm font-bold text-brand-navy" data-id="element-180" data-mp="ib9tckxj887u">
                    {testimonial.name}
                  </p> : <span className="block h-3.5 w-28 rounded-full bg-brand-line" data-id="element-181" data-mp="3ls8gj3w9scqj" />}
                {testimonial.role ? <p className="text-xs text-brand-gray" data-id="element-182" data-mp="3qqa0dr1isg32">{testimonial.role}</p> : <span className="block h-3 w-20 rounded-full bg-brand-line/70" data-id="element-183" data-mp="3vk4emeycw2ur" />}
              </div>
              <span className="sr-only" data-id="element-184" data-mp="2y130ooqbxkg8">
                Bewertung — Text folgt in Kürze.
              </span>
            </article>)}
        </div>
      </Reveal>
    </section>;
}
function PlaceholderLines() {
  return <div className="space-y-2.5" aria-hidden="true" data-id="element-185" data-mp="1g5u0qnaxdyma">
      <span className="block h-3 w-full rounded-full bg-brand-line" data-id="element-186" data-mp="1g6c381o6l92n" />
      <span className="block h-3 w-11/12 rounded-full bg-brand-line" data-id="element-187" data-mp="1b5enrwuk2t4u" />
      <span className="block h-3 w-2/3 rounded-full bg-brand-line" data-id="element-188" data-mp="167muozi6d0z2" />
    </div>;
}